const campaign_item_data = [
  {
    id: "campaign_1",
    title: "Water for Life",
    image: "/images/avatars/avatar_1.jpg",
    icon: true,
    creator: "think_ocean",
    text: "Unique, fully 3D and built to unite the design multiverse. Designed and styled by ThinkOcean.",
    amount: "7,080.95",
    details: [
      {
        id: "07.2K",
        detailsNumber: "Open",
        detailsText: "Type",
      },
      {
        id: "15.3K",
        detailsNumber: "Think Ocean",
        detailsText: "Owner",
      },
      {
        id: "22.55",
        detailsNumber: "Arts & Culture",
        detailsText: "Category",
      },
      {
        id: "317.2K",
        detailsNumber: "133234",
        detailsText: "Reg. Number",
      },
      {
        id: "17.2K",
        detailsNumber: "1000 $",
        detailsText: "Amount Raised",
      },
      {
        id: ".2K",
        detailsNumber: "Cause",
        detailsText: "User Type",
      },
      {
        id: "20K",
        detailsNumber: "May 01 2023",
        detailsText: "Start Date",
      },
      {
        id: "30K",
        detailsNumber: "May 01 2024",
        detailsText: "End Date",
      },
    ],
  },
];

const campaign_why_support_us_data = [
  {
    id: "0Lazyone Panda",
    image: "/images/avatars/avatar_2.jpg",
    title: "Campaign Overview",
    price: "sold for 1.515 ETH",
    time: "30 minutes 45 seconds ago",
    category: "overview",
    description:
      "Welcome to the Positive Vibes Campaign - a way for everyone to get involved and join youth on a mission to support children and young people in need. How does it work? There are youth projects around the world that need your help. You can support by buying one of the image impact tokens created by youth and other supporters OR contributing an image that will be sold as an impact token. If you buy one of the images, this will be an impact token that builds your impact portfolio that you can share, AND it will also be your token ticket to the Positive Vibes Festival for Youth Day 2024.  If you contribute an image, you can also earn from it if its bought – and it will then be an impact token ticket too. We are also working to twin schools and organisations with projects in need. We don't ask for a lot, all you need is a bit of inspiration to create some images or awesome photos that can be contributed to a campaign. Once you have these, add it to a campaign, promote it to your networks to get them supporting AND you earn while supporting a project of your choice while building your impact portfolio! Get in touch at aunuaglobal.org to find out more about how this works, and you can check out some of the projects you could twin with to support here: https://impactoverse.com/browse-sub-campaign/63c42a6b4df378abfe55cd84 What will funds from this campaign support? 1) By October of 2023 we aim to raise $1000 to support at least 10 sub-campaigns aimed at improving the lives of children and young people with their Positive Vibes campaigns so that they can fundraise for their own needs. 2) By January 2024 we aim to raise $10 000 to build out the ROAR app that supports youth with training and support on their impact journeys, and that also gives them an outlet for their creativity through AUNUA Stage - our youth media programme. We aim to onboard at least 200 children and young people by this time. 3) By August 2024 we aim to have raised $30 000, (alongside additional sponsorships), to build out the AUNUA Youth Academy in the Metaverse of Impact, giving youth opportunities without borders. More on the Positive Vibes Movement: AUNUA Global in Partnership with Skyler Jett and his charity Music for Global Change, launched the Positive Vibes Movement which champions more positive action that leads to more positive vibes around the world. What would YOUR world be like with more love and kindness?! Let's find out with Positive Vibes! Find out more on aunuaglobal.com",
    impactMilestones: [
      {
        milestone: "Milestone 1",
        milestoneHeading: "Sub-campaigns for children and young people",
        milestoneDescription:
          "Engage with and onboard sub-campaigns benefiting children and young people. Support them in running campaigns to fundraise for SDG aligned goals.",
        milestoneDate: "2023-10-31T00:00:00.000Z",
        milestonesKPIs: [
          {
            0: "Identify 10 projects that will benefit children and young people and engage with them around campaigns they can run to fundraise for SDG aligned goals",
            1: "Support with compiling their campaign stories and helping them with a campaign strategy",
            2: "Onboard them onto the platform and support with an outreach strategy",
          },
        ],
      },
      {
        milestone: "Milestone 2",
        milestoneHeading: "Sub-campaigns for children and young people",
        milestoneDescription:
          "Engage with and onboard sub-campaigns benefiting children and young people. Support them in running campaigns to fundraise for SDG aligned goals.",
        milestoneDate: "2023-10-31T00:00:00.000Z",
        milestonesKPIs: [
          {
            0: "Identify 10 projects that will benefit children and young people and engage with them around campaigns they can run to fundraise for SDG aligned goals",
            1: "Support with compiling their campaign stories and helping them with a campaign strategy",
            2: "Onboard them onto the platform and support with an outreach strategy",
          },
        ],
      },
      {
        milestone: "Milestone 3",
        milestoneHeading: "Sub-campaigns for children and young people",
        milestoneDescription:
          "Engage with and onboard sub-campaigns benefiting children and young people. Support them in running campaigns to fundraise for SDG aligned goals.",
        milestoneDate: "2023-10-31T00:00:00.000Z",
        milestonesKPIs: [
          {
            0: "Identify 10 projects that will benefit children and young people and engage with them around campaigns they can run to fundraise for SDG aligned goals",
            1: "Support with compiling their campaign stories and helping them with a campaign strategy",
            2: "Onboard them onto the platform and support with an outreach strategy",
          },
        ],
      },
    ],
  },
  {
    id: "1Impact Art Funny Cat",
    image: "/images/avatars/avatar_1.jpg",
    // image: '/images/products/item_21_sm.jpg',
    title: "Impact",
    price: "listed by 051_Hart .08095 ETH",
    time: "40 minutes 36 seconds ago",
    category: "impact",
    description:
      "Welcome to the Positive Vibes Campaign - a way for everyone to get involved and join youth on a mission to support children and young people in need. How does it work? There are youth projects around the world that need your help. You can support by buying one of the image impact tokens created by youth and other supporters OR contributing an image that will be sold as an impact token. If you buy one of the images, this will be an impact token that builds your impact portfolio that you can share, AND it will also be your token ticket to the Positive Vibes Festival for Youth Day 2024.  If you contribute an image, you can also earn from it if its bought – and it will then be an impact token ticket too. We are also working to twin schools and organisations with projects in need. We don't ask for a lot, all you need is a bit of inspiration to create some images or awesome photos that can be contributed to a campaign. Once you have these, add it to a campaign, promote it to your networks to get them supporting AND you earn while supporting a project of your choice while building your impact portfolio! Get in touch at aunuaglobal.org to find out more about how this works, and you can check out some of the projects you could twin with to support here: https://impactoverse.com/browse-sub-campaign/63c42a6b4df378abfe55cd84 What will funds from this campaign support? 1) By October of 2023 we aim to raise $1000 to support at least 10 sub-campaigns aimed at improving the lives of children and young people with their Positive Vibes campaigns so that they can fundraise for their own needs. 2) By January 2024 we aim to raise $10 000 to build out the ROAR app that supports youth with training and support on their impact journeys, and that also gives them an outlet for their creativity through AUNUA Stage - our youth media programme. We aim to onboard at least 200 children and young people by this time. 3) By August 2024 we aim to have raised $30 000, (alongside additional sponsorships), to build out the AUNUA Youth Academy in the Metaverse of Impact, giving youth opportunities without borders. More on the Positive Vibes Movement: AUNUA Global in Partnership with Skyler Jett and his charity Music for Global Change, launched the Positive Vibes Movement which champions more positive action that leads to more positive vibes around the world. What would YOUR world be like with more love and kindness?! Let's find out with Positive Vibes! Find out more on aunuaglobal.com",
    impactMilestones: [
      {
        milestone: "Milestone 1",
        milestoneHeading: "Sub-campaigns for children and young people",
        milestoneDescription:
          "Engage with and onboard sub-campaigns benefiting children and young people. Support them in running campaigns to fundraise for SDG aligned goals.",
        milestoneDate: "2023-10-31T00:00:00.000Z",
        milestonesKPIs: [
          {
            0: "Identify 10 projects that will benefit children and young people and engage with them around campaigns they can run to fundraise for SDG aligned goals",
            1: "Support with compiling their campaign stories and helping them with a campaign strategy",
            2: "Onboard them onto the platform and support with an outreach strategy",
          },
        ],
      },
      {
        milestone: "Milestone 1",
        milestoneHeading: "Sub-campaigns for children and young people",
        milestoneDescription:
          "Engage with and onboard sub-campaigns benefiting children and young people. Support them in running campaigns to fundraise for SDG aligned goals.",
        milestoneDate: "2023-10-31T00:00:00.000Z",
        milestonesKPIs: [
          {
            0: "Identify 10 projects that will benefit children and young people and engage with them around campaigns they can run to fundraise for SDG aligned goals",
            1: "Support with compiling their campaign stories and helping them with a campaign strategy",
            2: "Onboard them onto the platform and support with an outreach strategy",
          },
        ],
      },
      {
        milestone: "Milestone 1",
        milestoneHeading: "Sub-campaigns for children and young people",
        milestoneDescription:
          "Engage with and onboard sub-campaigns benefiting children and young people. Support them in running campaigns to fundraise for SDG aligned goals.",
        milestoneDate: "2023-10-31T00:00:00.000Z",
        milestonesKPIs: [
          {
            0: "Identify 10 projects that will benefit children and young people and engage with them around campaigns they can run to fundraise for SDG aligned goals",
            1: "Support with compiling their campaign stories and helping them with a campaign strategy",
            2: "Onboard them onto the platform and support with an outreach strategy",
          },
        ],
      },
    ],
  },
  {
    id: "2Prince Ape Planet",
    image: "/images/avatars/avatar_3.jpg",
    // image: '/images/products/item_22_sm.jpg',
    title: "Feasibility",
    price: "tranferred from 027ab52",
    time: "1 hour 15 minutes ago",
    category: "feasibility",
    description:
      "Welcome to the Positive Vibes Campaign - a way for everyone to get involved and join youth on a mission to support children and young people in need. How does it work? There are youth projects around the world that need your help. You can support by buying one of the image impact tokens created by youth and other supporters OR contributing an image that will be sold as an impact token. If you buy one of the images, this will be an impact token that builds your impact portfolio that you can share, AND it will also be your token ticket to the Positive Vibes Festival for Youth Day 2024.  If you contribute an image, you can also earn from it if its bought – and it will then be an impact token ticket too. We are also working to twin schools and organisations with projects in need. We don't ask for a lot, all you need is a bit of inspiration to create some images or awesome photos that can be contributed to a campaign. Once you have these, add it to a campaign, promote it to your networks to get them supporting AND you earn while supporting a project of your choice while building your impact portfolio! Get in touch at aunuaglobal.org to find out more about how this works, and you can check out some of the projects you could twin with to support here: https://impactoverse.com/browse-sub-campaign/63c42a6b4df378abfe55cd84 What will funds from this campaign support? 1) By October of 2023 we aim to raise $1000 to support at least 10 sub-campaigns aimed at improving the lives of children and young people with their Positive Vibes campaigns so that they can fundraise for their own needs. 2) By January 2024 we aim to raise $10 000 to build out the ROAR app that supports youth with training and support on their impact journeys, and that also gives them an outlet for their creativity through AUNUA Stage - our youth media programme. We aim to onboard at least 200 children and young people by this time. 3) By August 2024 we aim to have raised $30 000, (alongside additional sponsorships), to build out the AUNUA Youth Academy in the Metaverse of Impact, giving youth opportunities without borders. More on the Positive Vibes Movement: AUNUA Global in Partnership with Skyler Jett and his charity Music for Global Change, launched the Positive Vibes Movement which champions more positive action that leads to more positive vibes around the world. What would YOUR world be like with more love and kindness?! Let's find out with Positive Vibes! Find out more on aunuaglobal.com",
    impactMilestones: [
      {
        milestone: "Milestone 1",
        milestoneHeading: "Sub-campaigns for children and young people",
        milestoneDescription:
          "Engage with and onboard sub-campaigns benefiting children and young people. Support them in running campaigns to fundraise for SDG aligned goals.",
        milestoneDate: "2023-10-31T00:00:00.000Z",
        milestonesKPIs: [
          {
            0: "Identify 10 projects that will benefit children and young people and engage with them around campaigns they can run to fundraise for SDG aligned goals",
            1: "Support with compiling their campaign stories and helping them with a campaign strategy",
            2: "Onboard them onto the platform and support with an outreach strategy",
          },
        ],
      },
      {
        milestone: "Milestone 1",
        milestoneHeading: "Sub-campaigns for children and young people",
        milestoneDescription:
          "Engage with and onboard sub-campaigns benefiting children and young people. Support them in running campaigns to fundraise for SDG aligned goals.",
        milestoneDate: "2023-10-31T00:00:00.000Z",
        milestonesKPIs: [
          {
            0: "Identify 10 projects that will benefit children and young people and engage with them around campaigns they can run to fundraise for SDG aligned goals",
            1: "Support with compiling their campaign stories and helping them with a campaign strategy",
            2: "Onboard them onto the platform and support with an outreach strategy",
          },
        ],
      },
      {
        milestone: "Milestone 1",
        milestoneHeading: "Sub-campaigns for children and young people",
        milestoneDescription:
          "Engage with and onboard sub-campaigns benefiting children and young people. Support them in running campaigns to fundraise for SDG aligned goals.",
        milestoneDate: "2023-10-31T00:00:00.000Z",
        milestonesKPIs: [
          {
            0: "Identify 10 projects that will benefit children and young people and engage with them around campaigns they can run to fundraise for SDG aligned goals",
            1: "Support with compiling their campaign stories and helping them with a campaign strategy",
            2: "Onboard them onto the platform and support with an outreach strategy",
          },
        ],
      },
    ],
  },
];

const campaign_reporting = [
  {
    id: "0Lazyone Panda",
    image: "/images/avatars/avatar_2.jpg",
    milestoneTitle: "Milestone 1",
    reportingTitle: "SOME INDICATOR",
    reportingDescription: "Milestone Description of the campagin",
    oppurnityCollaborate: "Opportunities to Collaborate",
    oppurnityCollaborateDescription:
      "jhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhg",
    challengesTitle: "Challenges and Solutions",
    challengesDescription:
      "jhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhg",
    lessonLearnedTitle: "Lesson Learned",
    lessonLearnedDescription:
      "jhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhg",
    photos: [],
    title: "Lazyone Panda",
    price: "sold for 1.515 ETH",
    time: "30 minutes 45 seconds ago",
    category: "milestone 1",
  },
  {
    id: "1Impact Art Funny Cat",
    image: "/images/avatars/avatar_1.jpg",
    // image: '/images/products/item_21_sm.jpg',
    milestoneTitle: "Milestone 2",
    reportingTitle: "SOME INDICATOR",
    reportingDescription: "Milestone Description of the campagin",
    oppurnityCollaborate: "Opportunities to Collaborate",
    oppurnityCollaborateDescription:
      "jhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhg",
    challengesTitle: "Challenges and Solutions",
    challengesDescription:
      "jhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhg",
    lessonLearned:
      "jhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhg",
    photos: [],
    title: "Impact Art Funny Cat",
    price: "listed by 051_Hart .08095 ETH",
    time: "40 minutes 36 seconds ago",
    category: "milestone 2",
  },
  {
    id: "2Prince Ape Planet",
    image: "/images/avatars/avatar_3.jpg",
    // image: '/images/products/item_22_sm.jpg',
    milestoneTitle: "Milestone 3",
    reportingTitle: "SOME INDICATOR",
    reportingDescription: "Milestone Description of the campagin",
    oppurnityCollaborate: "Opportunities to Collaborate",
    oppurnityCollaborateDescription:
      "jhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhg",
    challengesTitle: "Challenges and Solutions",
    challengesDescription:
      "jhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhg",
    lessonLearned:
      "jhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhg",
    photos: [],
    title: "Prince Ape Planet",
    price: "tranferred from 027ab52",
    time: "1 hour 15 minutes ago",
    category: "milestone 3",
  },
  {
    id: "3Origin Morish",
    image: "/images/avatars/avatar_4.jpg",
    milestoneTitle: "Milestone 4",
    reportingTitle: "SOME INDICATOR",
    reportingDescription: "Milestone Description of the campagin",
    oppurnityCollaborate: "Opportunities to Collaborate",
    oppurnityCollaborateDescription:
      "jhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhg",
    challengesTitle: "Challenges and Solutions",
    challengesDescription:
      "jhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhg",
    lessonLearned:
      "jhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhg",
    photos: [],
    // image: '/images/products/item_23_sm.jpg',
    title: "Origin Morish",
    price: "bid cancelled by 0397fd",
    time: "1 hour 55 minutes ago",
    category: "milestone 4",
  },
  {
    id: "4Portrait Gallery#029",
    image: "/images/avatars/avatar_5.jpg",
    milestoneTitle: "Milestone 5",
    reportingTitle: "SOME INDICATOR",
    reportingDescription: "Milestone Description of the campagin",
    oppurnityCollaborate: "Opportunities to Collaborate",
    oppurnityCollaborateDescription:
      "jhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhg",
    challengesTitle: "Challenges and Solutions",
    challengesDescription:
      "jhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhg",
    lessonLearned:
      "jhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhgjhgjhgjhgjhgjhjhgjhjhgjhgjhgjhgjhjhg",
    photos: [],
    // image: '/images/products/item_24_sm.jpg',
    title: "Portrait Gallery#029",
    price: "liked by Trina_more",
    time: "2 hours 24 minutes ago",
    category: "milestone 5",
  },

  // =============
  // =============
  // =============
];

export { campaign_item_data, campaign_why_support_us_data, campaign_reporting };
